// JS
import React, { useState, useEffect } from 'react';

const BrandsHero = ({
  // Setup prop defaults
  backgroundImg,
  allBrandsData
}) => {
  const [brandsData, setBrandsData] = useState([]);
  const [filterBrands, setFilterBrands] = useState([]);
  const [search, setSearch] = useState('');
  const [searchShow, setSearchShow] = useState(false);

  useEffect(() => {
    if (allBrandsData && allBrandsData.hierarchy) {
      setBrandsData(allBrandsData.hierarchy);
    }
  }, [allBrandsData]);

  // FILTER SEARCH RESULTS
  useEffect(() => {
    setFilterBrands(
      brandsData.filter((brand) => {
        return brand.name.toLowerCase().includes(search.toLowerCase());
      })
    );
  }, [search, brandsData]);

  const searchClickOutside = (e) => {
    if (searchShow) setSearchShow(false);
  };

  const handleSearchShow = (e) => {
    setSearch(e.target.value);
    e.target.value.length >= 2 ? setSearchShow(true) : setSearchShow(false);
  };

  return (
    <section
      className="relative bg-center bg-cover"
      style={{
        backgroundImage: `url(${backgroundImg})`
      }}
    >
      <div className="container overflow-visible">
        <div className="flex flex-col items-center justify-center px-0 md:px-2.5 py-24 md:py-36 lg:py-44 xl:py-52">
          <div>
            <label
              htmlFor="search-bar"
              className="relative z-30 flex items-center justify-between w-full bg-white py-6 lg:py-7 px-8 md:px-10 m-0"
            >
              <input
                id="search-bar"
                type="text"
                name="search"
                placeholder="Search for a brand"
                autoComplete="off"
                className="outline-none border-0 m-0 p-0 h-auto font-base min-w-[225px] md:min-w-[290px] lg:min-w-[420px]"
                onChange={handleSearchShow}
                onClick={handleSearchShow}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 17"
                className=" w-6 h-6"
              >
                <g
                  fill="none"
                  stroke="#000"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                  transform="translate(1 1.068)"
                >
                  <circle
                    cx="7"
                    cy="7"
                    r="7"
                    transform="translate(0 -.068)"
                    strokeLinecap="round"
                  />
                  <path d="m16 16-4.4-4.4" />
                </g>
              </svg>
            </label>
            {searchShow && (
              <div className="relative">
                <div
                  className="fixed z-20 w-full h-full inset-0 bg-black/70 cursor-pointer"
                  onClick={searchClickOutside}
                />
                <div className="absolute z-30 w-full h-auto max-h-[412px] bg-white border-t border-solid border-t-gray-300 overflow-y-auto">
                  <ul className="list-none text-sm text-black leading-8 py-7 px-10">
                    {filterBrands && filterBrands.length < 1 ? (
                      <div className="text-gray-400">No brands found</div>
                    ) : (
                      filterBrands.map((item, index) => (
                        <li
                          key={'search-brand-' + index}
                          className="pb-4 last:pb-0 m-0"
                        >
                          <a
                            href={item.data.url}
                            className="whitespace-nowrap overflow-hidden text-ellipsis hover:underline"
                          >
                            {item.name}
                          </a>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsHero;
